import { useIsMutating } from "@tanstack/react-query";

const LOADING_MESSAGES: string[] = [
  "Processing your request…",
  "Crunching the numbers…",
  "Almost there…",
  "Updating records…",
];

export default function GlobalLoadingOverlay() {
  const isMutating = useIsMutating();

  if (!isMutating) return null;

  const message = LOADING_MESSAGES[0];

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.55)", backdropFilter: "blur(3px)" }}
    >
      <div className="bg-white rounded-2xl shadow-2xl flex flex-col items-center gap-5 px-12 py-10 min-w-[260px]">
        {/* Spinner */}
        <div className="relative w-16 h-16">
          {/* Track ring */}
          <div className="absolute inset-0 rounded-full border-4 border-slate-100" />
          {/* Spinning arc */}
          <div
            className="absolute inset-0 rounded-full border-4 border-transparent animate-spin"
            style={{ borderTopColor: "#2563eb" }}
          />
          {/* Inner pulse dot */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-3 h-3 rounded-full bg-blue-600 animate-pulse" />
          </div>
        </div>

        {/* Text */}
        <div className="text-center space-y-1">
          <p className="text-slate-800 font-semibold text-sm tracking-wide">
            {message}
          </p>
          <p className="text-slate-400 text-xs">
            Please wait — do not close or refresh
          </p>
        </div>

        {/* Progress bar */}
        <div className="w-full h-1 bg-slate-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 rounded-full"
            style={{
              animation: "progressPulse 1.4s ease-in-out infinite",
              width: "40%",
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes progressPulse {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(150%); }
          100% { transform: translateX(350%); }
        }
      `}</style>
    </div>
  );
}
